import getEnv, { isCxApp } from "@/common/util/env"
import { ProtectedRoutes } from "@/router/IRoute"
import { includes } from "lodash"
import { useLinks } from "@/composables/useLinks"

export const primaryMenu = [
  {
    title: "Home",
    textKey: "sideMenu.home",
    iconClass: "home",
    iconSize: 28,
    hasChild: false,
    path: "/home",
    pathName: "home",
    isOpen: false,
    isActive: true
  },
  {
    title: "",
    textKey: "sideMenu.prepare",
    iconClass: "prepare",
    iconSize: 20,
    hasChild: true,
    isOpen: false,
    isActive: isCxApp(),
    childrens: [
      {
        title: "My memberships",
        textKey: "sideMenu.model",
        path: ProtectedRoutes.prepare.models.path,
        pathName: ProtectedRoutes.prepare.models.pathName,
        isActive: isCxApp()
      },
      {
        title: "My memberships",
        textKey: "sideMenu.mapping",
        path: "mapping",
        pathName: "mapping",
        isActive: isCxApp(),
        isDisabled: !includes(getEnv("VITE_APP_FEATURES"), "crossrelations")
      },
      {
        title: "My memberships",
        textKey: "sideMenu.converter",
        path: "converter",
        pathName: "converter",
        isActive: isCxApp(),
        isDisabled: !includes(getEnv("VITE_APP_FEATURES"), "converters")
      }
    ]
  },
  {
    title: "",
    textKey: "sideMenu.provide",
    iconClass: "upload-to-cloud",
    iconSize: 20,
    hasChild: true,
    isOpen: false,
    isActive: true,
    childrens: [
      {
        title: "",
        textKey: "sideMenu.assets",
        path: "/",
        pathName: "",
        isActive: false,
        isDisabled: true
      },
      {
        title: "",
        textKey: "sideMenu.publishData",
        path: ProtectedRoutes.provider.configure.path,
        pathName: ProtectedRoutes.provider.configure.pathName,
        isActive: true
      },
      {
        title: "",
        textKey: "sideMenu.policyPublicationTemplate",
        path: "/",
        pathName: "",
        isActive: isCxApp(),
        isDisabled: true
      },
      {
        title: "",
        textKey: "sideMenu.uploadHistory",
        path: ProtectedRoutes.provider.uploadHistory.path,
        pathName: ProtectedRoutes.provider.uploadHistory.pathName,
        isActive: true,
        isDisabled: isCxApp() ? true : false
      }
    ]
  },
  {
    title: "",
    textKey: "sideMenu.consume",
    iconClass: '<scale-icon-content-shop accessibility-title="shop"/>',
    iconSize: 20,
    hasChild: true,
    isOpen: false,
    isActive: true,
    childrens: [
      {
        title: "",
        textKey: "sideMenu.searchDataOffers",
        path: ProtectedRoutes.consume.offers.path,
        pathName: ProtectedRoutes.consume.offers.pathName,
        isActive: true
      },
      {
        title: "",
        textKey: "sideMenu.negotiatedDataOffers",
        path: "/",
        pathName: "",
        isActive: isCxApp(),
        isDisabled: true
      },
      {
        title: "",
        textKey: "sideMenu.downloadHistory",
        path: "/",
        pathName: "",
        isActive: isCxApp() ? true : false,
        isDisabled: true
      }
    ]
  },
  {
    title: "",
    textKey: "sideMenu.govern",
    iconClass: '<scale-icon-user-file-admin accessibility-title="admin"/>',
    iconSize: 20,
    hasChild: true,
    isOpen: false,
    isActive: true,
    isDisabled: isCxApp(),
    childrens: [
      {
        title: "",
        textKey: "sideMenu.myPolicies",
        path: ProtectedRoutes.govern.policy.path,
        pathName: ProtectedRoutes.govern.policy.pathName,
        isActive: !isCxApp()
      },
      {
        title: "",
        textKey: "sideMenu.contractDefinitions",
        path: "/",
        pathName: "",
        isActive: false,
        isDisabled: true
      },

      {
        title: "",
        textKey: "sideMenu.outgoingAgreements",
        path: ProtectedRoutes.govern.outgoingAgreements.path,
        pathName: ProtectedRoutes.govern.outgoingAgreements.pathName,
        isActive: !isCxApp()
      },
      {
        title: "",
        textKey: "sideMenu.consumeAutomation",
        path: "/",
        pathName: "",
        isActive: false,
        isDisabled: true
      },
      {
        title: "",
        textKey: "sideMenu.incomingAgreements",
        path: "/",
        pathName: "",
        isActive: false,
        isDisabled: true
      },
      {
        title: "",
        textKey: "sideMenu.subscribedAgreements",
        path: ProtectedRoutes.govern.subscribedAgreements.path,
        pathName: ProtectedRoutes.govern.subscribedAgreements.pathName,
        isActive: !isCxApp()
      }
    ]
  },
  {
    title: "",
    textKey: "sideMenu.manageAndConfig",
    iconClass: '<scale-icon-service-maintanance accessibility-title="maintanance"/>',
    iconSize: 20,
    hasChild: true,
    isOpen: false,
    isActive: isCxApp(),
    isDisabled: true,
    childrens: [
      {
        title: "",
        textKey: "sideMenu.connections",
        path: "/",
        pathName: "",
        isActive: false,
        isDisabled: true
      }
    ]
  },
  {
    title: "",
    textKey: "sideMenu.monitoring",
    iconClass: '<scale-icon-content-data-visualisation accessibility-title="data-visualisation"/>',
    iconSize: 20,
    hasChild: true,
    isOpen: false,
    isActive: isCxApp(),
    isDisabled: false,
    childrens: [
      {
        title: "",
        textKey: "sideMenu.networkAnalytics",
        path: "/",
        pathName: "",
        isActive: false,
        isDisabled: true
      },
      {
        title: "",
        textKey: "sideMenu.jobs",
        path: ProtectedRoutes.jobs.path,
        pathName: ProtectedRoutes.jobs.pathName,
        isActive: isCxApp()
      },
      {
        title: "",
        textKey: "sideMenu.otherLogs",
        path: "/",
        pathName: "",
        isActive: false,
        isDisabled: true
      }
    ]
  }
]

export const secondaryMenu = [
  {
    title: "Help",
    textKey: "sideMenu.help",
    iconClass: "help",
    iconSize: 20,
    hasChild: true,
    isOpen: false,
    isActive: true,
    childrens: [
      {
        title: "",
        textKey: "sideMenu.licences",
        path: useLinks().helpSection().licences,
        isExternalLink: true,
        pathName: "",
        isActive: true
      }
    ]
  }
]

export const defaultCollapseMenuItem = {
  title: "Collapse sidebar",
  textKey: "sideMenu.collapse",
  iconClass: "arrows-left",
  iconSize: 20,
  hasChild: false,
  path: "#",
  pathName: "#",
  isOpen: false,
  isFontMedium: true,
  isHeading: true,
  isRotateIcon: true,
  isActive: true
}

export interface IntMenuItem {
  title: string
  textKey: string
  iconClass: string
  iconSize?: number
  hasChild?: boolean
  path?: string
  pathName?: string
  childrens?: IntMenuItemChildren[]
  isOpen: boolean
  isActive: boolean
  isFontMedium?: boolean
  isHeading?: boolean
  isDisabled?: boolean
  isExternalLink?: boolean
}

export interface IntMenuItemChildren {
  title: string
  textKey: string
  iconClass?: string
  path?: string
  pathName?: string
  isOpen?: boolean
  isActive: boolean
  isDisabled?: boolean
  isExternalLink?: boolean
}

export interface IntMenuItemEmitPayload {
  type: string
  menuItem: IntMenuItem
  index: number
}

export interface IntChildEmitPayload {
  type?: string
  childItem: IntMenuItemChildren
  childItemIndex: number
  menuItem: IntMenuItem
}
